import React from "react";

const Banner = ({ bannerImage, children, className }) => {
  return (
    <div className={`site-container ${className || ""} error-message`}>
      <div className="relative hidden h-[50vh] min-h-[300px] max-h-[520px] lg:block">
        <img
          src={
            bannerImage &&
            process.env.REACT_APP_HAPS_MEDIA_BASE_URL +
              bannerImage.offer_web_path
          }
          alt="Fina Interiors offer banner"
          className="h-full w-full object-cover"
        />
        {children}
      </div>
      <div className="relative block h-[42vh] min-h-[240px] max-h-[420px] lg:hidden">
        <img
          src={
            bannerImage &&
            process.env.REACT_APP_HAPS_MEDIA_BASE_URL +
              bannerImage.offer_mobile_path
          }
          alt="Fina Interiors offer banner"
          className="h-full w-full object-cover"
        />
      </div>
    </div>
  );
};

export default Banner;
